import { section, setScreenHeightVars } from "@/neon";
import { add } from "@fluorescent/dom";

import isFirstSectionOnHomepage from "@/lib/homePage";
import { animateImageHero } from "@/lib/animation";

section("image-hero", {
  onLoad() {
    if (isFirstSectionOnHomepage(this.container)) {
      add(this.container, "first-full-height");

      // Use px instead of default vh for height vars to avoid CLS within section previews
      if (window.Shopify.visualPreviewMode === true) {
        add(this.container, "visual-preview");
        setScreenHeightVars(this.container);
      }
    }

    this.animateImageHero = animateImageHero(this.container);
  },

  onUnload() {
    this.animateImageHero?.destroy();
  },
});
